import Notify from "./../notify"
import CustomSelect from "./select";
export default class ObjectsOrdersFilter {
    constructor() {
        this.data = {};
        this.ajaxUrl = "/themes/ahtilahti/ajax/object-orders-list.php";

    }



    search() {
        let str = window.location.search;
        let objURL = [];
        str.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function(
            $0,
            $1,
            $2,
            $3
        ) {
            objURL.push($3);
        });


        for (let i = 0; i < objURL.length; i++) {
            if (objURL[i] == "past" || objURL[i] == "current") {
                this.data.sort = objURL[i];
            }
        }



        $.ajax({
            method: "POST",
            url: this.ajaxUrl,
            async: false,
            data: this.data,
            success: function(response) {
                // console.log(response);
                // if (pagination) {
                //     pagination = $(response).find(instance.paginationContainer).html();
                //     let items = $(response).html();
                //     $(instance.contanerCollection).append(items);
                //     $(instance.paginationContainer).empty();
                //     $(instance.paginationContainer).append(pagination);
                // } else {

                $("#container-arend-orders").html(response);

                // }

            },
            error(xhr, status, error) {
                new Notify($.parseJSON(xhr.responseText).message, "alert");
            }
        });
    }


    init() {
        let instance = this;

        $(document).on("keyup", "#order-q", function(e) {
            e.preventDefault();
            instance.data.q = $(this).val();
            instance.search();
        });


        if ($("#location-select-order").length) {
            const select = new CustomSelect('#location-select-order');
        }


        $("#location-select-order .select__item").on("click", function(e) {

            e.preventDefault();
            instance.data.q = $(this).attr("value");
            instance.search();
            // 
        });

        $(document).on("keyup", "#order-s", function(e) {
            e.preventDefault();
            instance.data.s = $(this).val();
            instance.search();
        });

        $(document).on("change", "#objects-order-select-status", function(e) {
            e.preventDefault();
            instance.data.status = $(this).val();
            instance.search();

        });

        $(document).on("change", "#objects-order-select-ordered", function(e) {
            e.preventDefault();
            instance.data.ordered = $(this).val();
            instance.search();
        });


        $(document).on("change", "#select-order-sort-name", function(e) {
            e.preventDefault();
            instance.data.date = $(this).val();
            instance.search();

        });



        // $(document).on("change", "#select-sort-name", function(e) {
        //     e.preventDefault();
        //     instance.data.name = $(this).val();
        //     instance.search();

        // });

        // $(document).on("change", "#select-sort-number", function(e) {
        //     e.preventDefault();
        //     instance.data.number = $(this).val();
        //     instance.search();

        // });

        // $(document).on("keyup", "#location", function(e) {
        //     e.preventDefault();
        //     instance.data.location = $(this).val();
        //     instance.search();

        // });



    }
}